module.exports = __webpack_public_path__ + "static/45invgde-c102cadde42c5d7a96a30fa49167d89e.gif";